import Checkbox from '@mui/material/Checkbox';
import LanguageCheckOn from '../../images/LanguageIcons/language-check-on.svg';
import LanguageCheckOff from '../../images/LanguageIcons/language-check-off.svg';
import i18n from '../../utils/i18n';

const CheckboxLanguage = ({
	imgSrc,
	languageName,
	isSelected,
	onSelect,
	marginBottom = '12px',
}) => {
	return (
		<div
			style={{
				display: 'flex',
				borderRadius: '6px',
				overflow: 'hidden',
				border: '1px solid #e0e0e0',
				backgroundColor: '#fff',
				marginBottom: marginBottom,
				cursor: 'pointer',
			}}
			onClick={onSelect}>
			<div
				style={{
					backgroundColor: '#fafcfe',
					padding: '16px 16px',
					display: 'flex',
					alignItems: 'center',
					borderRight: '1px solid #e0e0e0',
					cursor: 'pointer',
				}}>
				<Checkbox
					checked={isSelected}
					onChange={onSelect}
					icon={
						<img
							src={LanguageCheckOff}
							alt={i18n.t('general.uncheckedIcon')}
							style={{
								width: '16px',
								height: '16px',
								cursor: 'pointer',
							}}
						/>
					}
					checkedIcon={
						<img
							src={LanguageCheckOn}
							alt={i18n.t('general.checkedIcon')}
							style={{
								width: '16px',
								height: '16px',
								cursor: 'pointer',
							}}
						/>
					}
					style={{
						padding: 0,
						cursor: 'pointer',
					}}
					onClick={(e) => e.stopPropagation()}
				/>
			</div>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					cursor: 'pointer',
				}}>
				<img
					src={imgSrc}
					alt={languageName}
					style={{
						width: '20px',
						height: '20px',
						margin: '8px 12px',
						cursor: 'pointer',
					}}
				/>
				<span
					style={{
						fontSize: '14px',
						fontWeight: 700,
						color: '#0b0f31',
						cursor: 'pointer',
					}}>
					{languageName}
				</span>
			</div>
		</div>
	);
};

export default CheckboxLanguage;
